import { createFileRoute } from '@tanstack/react-router';
import Application from '~/containers/Application';

export const Route = createFileRoute('/application')({
  component: Application,
});
